import React, { SyntheticEvent } from "react";
import ReactDOM from "react-dom";
import Snackbar from "@material-ui/core/Snackbar";
import SnackbarContent from "@material-ui/core/SnackbarContent";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import ErrorIcon from "@material-ui/icons/Error";
import InfoIcon from "@material-ui/icons/Info";
import WarningIcon from "@material-ui/icons/Warning";
import { makeStyles, Theme } from "@material-ui/core/styles";
import { green, amber } from "@material-ui/core/colors";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import SnackbarVariant from "../../../hooks/snackbar/SnackbarVariant";

const variantIcon = {
  success: CheckCircleIcon,
  warning: WarningIcon,
  error: ErrorIcon,
  info: InfoIcon
};

const useStyles = makeStyles((theme: Theme) => ({
  success: {
    backgroundColor: green[600]
  },
  error: {
    backgroundColor: theme.palette.error.dark
  },
  info: {
    backgroundColor: theme.palette.primary.main
  },
  warning: {
    backgroundColor: amber[700]
  },
  icon: {
    fontSize: 20
  },
  iconVariant: {
    opacity: 0.9,
    marginRight: theme.spacing(1)
  },
  message: {
    display: "flex",
    alignItems: "center"
  }
}));

interface Props {
  className?: string;
  message?: string;
  variant: keyof typeof SnackbarVariant;
  isOpened: boolean;
  onClose?: () => void;
}

export default function TrSnackbar({
  className,
  message,
  variant,
  isOpened,
  onClose
}: Props) {
  const classes = useStyles({});
  const Icon = variantIcon[variant];

  function handleClose(event?: SyntheticEvent, reason?: string) {
    if (reason === "clickaway") {
      return;
    }

    if (onClose) {
      onClose();
    }
  }

  return isOpened
    ? ReactDOM.createPortal(
        <Snackbar
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "center"
          }}
          open={isOpened}
          autoHideDuration={5000}
          onClose={handleClose}
        >
          <SnackbarContent
            className={`${classes[variant]} ${className}`}
            message={
              <span className={classes.message} style={{whiteSpace: 'pre-wrap'}}>
                <Icon className={`${classes.icon} ${classes.iconVariant}`} />
                {message}
              </span>
            }
            action={[
              <IconButton
                key="close"
                aria-label="close"
                color="inherit"
                onClick={onClose}
              >
                <CloseIcon className={classes.icon} />
              </IconButton>
            ]}
          />
        </Snackbar>,
        document.body
      )
    : null;
}
